import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../hooks/hooks';
import WebsitesComponent from '../components/website.component';
import PageLoader from '../../../../../components/PageLoader';
import { selectWebsiteCardsListItems } from '../../../../../redux/websiteCards/selector';
import { useSelector } from 'react-redux';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import storePersist from '../../../../../redux/storePersist';
import { websiteCards } from '../../../../../redux/websiteCards/action';
import { websites } from '../../../../../redux/websites/action';
import { stores } from '../../../../../redux/stores/action';
import { departments } from '../../../../../redux/departments/action';
import { selectStoresListItems } from '../../../../../redux/stores/selector';
import { selectDepartmentsListItems } from '../../../../../redux/departments/selector';

const ManagementWebsite = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const storeLists = useSelector(selectStoresListItems)
  const departmentLists = useSelector(selectDepartmentsListItems)
  const websiteCardsItems = useSelector(selectWebsiteCardsListItems)
  const websiteItems = useSelector(selectWebsitesListItems)
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectedTenantWebsites,
    setSelectedTenantWebsites
  ] = useState<any>([])
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTenantWebsites({ ...selectedTenantWebsites, [field]: event });
  }

  useEffect(
    () => {

      dispatch(websiteCards.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`, entity: 'websiteCards', jsonData: {
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            },
            {
              "FieldName": "PlatformWebSiteId",
              "FieldType": "number",
              "FilterOperatorId": 1,
              "FieldValue": parmas?.id
            }
          ],
        }
      }))


    },
    []
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`, entity: 'websiteCards', jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              TenantId: tenantId,
              StoreId: selectedTenantWebsites?.StoreId,
              DepartmentId: selectedTenantWebsites?.DepartmentId,
              PlatformWebSiteId: selectedTenantWebsites?.PlatformWebSiteId,
              WebSiteName: selectedTenantWebsites?.WebSiteName,
              Remarks: selectedTenantWebsites?.Remarks,
              HostingUrl: selectedTenantWebsites?.HostingUrl,
              MappedDomain: selectedTenantWebsites?.MappedDomain,
              DisplayOrder: selectedTenantWebsites?.DisplayOrder
            }
          }
        ]

      }
    }))

      .then(() => {
        back()
      })
  }

  const back = () => {
    navigate(`/management/cms/websites`)
  }
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'WebsiteName', headerName: 'WebsiteName', sortable: true, filter: true },
      { field: 'CardName', headerName: 'CardName' },
      { field: 'PageName', headerName: 'PageName' },
      { field: 'LayoutName', headerName: 'LayoutName' },

    ]);
  }

  useEffect(
    () => {
      dispatch(websites.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites/list`, entity: 'websites', jsonData: {} })).then(() => {
        dispatch(stores.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/stores/list`,
          entity: 'stores',
          jsonData: {
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ]
          }
        })).then(() => {
          dispatch(departments.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/departments/list`, entity: 'departments', jsonData: {

              Records: [
                {
                  Id: tenantId

                }
              ]

            }
          }))
        })
      })
      if (parmas?.id > 0) {
        createColumnDefs()
        setIsLoading(false)
        dispatch(websiteCards.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
          entity: 'websiteCards',
          jsonData: {
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              },
              {
                "FieldName": "PlatformWebSiteId",
                "FieldType": "number",
                "FilterOperatorId": 1,
                "FieldValue": parmas?.id
              }
            ],
          }
        }))
      }
      else {
        setIsLoading(false)
      }
    },
    []
  )
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)

  }
  const handleDelete = (data: any) => {
    dispatch(websiteCards.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/delete`,
      entity: 'websiteCards',
      jsonData: {
        Records: [
          {
            "Context": {},
            "Message": { CardId: data?.Id }

          }
        ]
      }
    })).then(() => {
      dispatch(websiteCards.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
        entity: 'websiteCards',
        jsonData: {
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            },
            {
              "FieldName": "PlatformWebSiteId",
              "FieldType": "number",
              "FilterOperatorId": 1,
              "FieldValue": parmas?.id
            }
          ],
        }
      }))
    });

  }
  const additionButtons: any = [
    {
      name: 'Back',
      callback: () => back(),
    }
  ];
  const formatWebsiteListData = (data: any) => {
    return _.map(data, (product: any) => {

      const item = {
        Id: product?.message?.Id,
        WebsiteName: product?.message?.WebsiteName,


      }
      return item
    });
  }
  return (
    <>
      {isLoading ? <PageLoader /> :
        <WebsitesComponent
          selectedTenantWebsites={selectedTenantWebsites}
          handleInnerFormChange={handleInnerFormChange}
          websites={formatWebsiteListData(websiteItems?.result?.items)}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onDelete={handleDelete}
          onEdit={handleEdit}
          rowData={websiteCardsItems?.result?.items}
          columnDefs={columnDefs}
          Id={parmas?.id}
          additionButtons={additionButtons}
          stores={storeLists?.result?.items}
          departments={departmentLists?.result?.items}
        />
      }
    </>
  )

}

export default ManagementWebsite;